// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alpha-selector--top {
  position: fixed;
  bottom: 16px;
  right: 16px;
  width: 56px;
  height: 56px;
  border-radius: 28px;
  box-shadow: 0px 4px 8px rgba(74, 74, 74, 0.3);
  background-color: #47888E;
  color: white;
  transition: background-color 300ms;
  opacity: 0;
  z-index: -1000;
  transition: opacity 300ms;
}

@media (min-width: 576px) {
  .alpha-selector--top {
    right: 48px;
    bottom: 48px;
  }
}
  
  .show-scrollTop {
    opacity: 1;
    z-index: 1001;
    transition: opacity 300ms;
  }
  
  .alpha-selector--top i {
    position: relative;
    display: inline-block;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    font-size: 48px;
  }
  
  .alpha-selector {
    padding-top: 0.438rem;
    margin-top: -1rem;			
    /* border: 1px solid green; */
  }
  .letter-link {
    position: relative;
    display: inline-block;
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 1.5rem;
    background: #47888E;
    font-weight: 600;
    font-size: 1.25rem;
    line-height: calc(2.5rem - 2px); /* Deliberately smaller than the height for alignment */
    text-align: center;
    text-transform: uppercase;
    margin-top: 8px;
    margin-right: 8px;
    /* border: 1px solid crimson; */
  }
  
  /* .letter-link:last-child {
    margin-right: 0;
  } */
  
  .letter-link--target {
    position: absolute;
    top: -0.25rem;
    left: -0.25rem;
    opacity: 0.3;
    width: 48px;
    height: 48px;
    cursor: pointer;
  }
  .letter-link:hover {
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
    transition: box-shadow 300ms;
  }
  
  .alpha-selector--top:hover,
  .letter-link:hover {
    background-color: #6FCBD2;
    transition: background-color 300ms;
  }
  
  
  .letter-link:focus {
    
  }
  
  .letter-link:active,
  .alpha-selector--top:active {
    background-color: #0085B3;
  }
  
  .letter-link,
  .letter-link:visited,
  .alpha-selector--top:visited {
    color: white;
  }
  
  .letter-link:not([href]) {
    background: #D8D8D8;
    cursor: default;
    box-shadow: none;
  }
  
  `, "",{"version":3,"sources":["webpack://./src/app/uilib/alpha-selector/alpha-selector.component.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6CAA6C;EAC7C,yBAAyB;EACzB,YAAY;EACZ,kCAAkC;EAClC,UAAU;EACV,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;EAEE;IACE,UAAU;IACV,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;IACR,SAAS;IACT,+BAA+B;IAC/B,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,6BAA6B;EAC/B;EACA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,cAAc;IACd,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,+BAA+B,EAAE,uDAAuD;IACxF,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,+BAA+B;EACjC;;EAEA;;KAEG;;EAEH;IACE,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;EACA;IACE,4CAA4C;IAC5C,4BAA4B;EAC9B;;EAEA;;IAEE,yBAAyB;IACzB,kCAAkC;EACpC;;;EAGA;;EAEA;;EAEA;;IAEE,yBAAyB;EAC3B;;EAEA;;;IAGE,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB","sourcesContent":[".alpha-selector--top {\r\n  position: fixed;\r\n  bottom: 16px;\r\n  right: 16px;\r\n  width: 56px;\r\n  height: 56px;\r\n  border-radius: 28px;\r\n  box-shadow: 0px 4px 8px rgba(74, 74, 74, 0.3);\r\n  background-color: #47888E;\r\n  color: white;\r\n  transition: background-color 300ms;\r\n  opacity: 0;\r\n  z-index: -1000;\r\n  transition: opacity 300ms;\r\n}\r\n\r\n@media (min-width: 576px) {\r\n  .alpha-selector--top {\r\n    right: 48px;\r\n    bottom: 48px;\r\n  }\r\n}\r\n  \r\n  .show-scrollTop {\r\n    opacity: 1;\r\n    z-index: 1001;\r\n    transition: opacity 300ms;\r\n  }\r\n  \r\n  .alpha-selector--top i {\r\n    position: relative;\r\n    display: inline-block;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%,-50%);\r\n    font-size: 48px;\r\n  }\r\n  \r\n  .alpha-selector {\r\n    padding-top: 0.438rem;\r\n    margin-top: -1rem;\t\t\t\r\n    /* border: 1px solid green; */\r\n  }\r\n  .letter-link {\r\n    position: relative;\r\n    display: inline-block;\r\n    width: 2.5rem;\r\n    height: 2.5rem;\r\n    border-radius: 1.5rem;\r\n    background: #47888E;\r\n    font-weight: 600;\r\n    font-size: 1.25rem;\r\n    line-height: calc(2.5rem - 2px); /* Deliberately smaller than the height for alignment */\r\n    text-align: center;\r\n    text-transform: uppercase;\r\n    margin-top: 8px;\r\n    margin-right: 8px;\r\n    /* border: 1px solid crimson; */\r\n  }\r\n  \r\n  /* .letter-link:last-child {\r\n    margin-right: 0;\r\n  } */\r\n  \r\n  .letter-link--target {\r\n    position: absolute;\r\n    top: -0.25rem;\r\n    left: -0.25rem;\r\n    opacity: 0.3;\r\n    width: 48px;\r\n    height: 48px;\r\n    cursor: pointer;\r\n  }\r\n  .letter-link:hover {\r\n    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);\r\n    transition: box-shadow 300ms;\r\n  }\r\n  \r\n  .alpha-selector--top:hover,\r\n  .letter-link:hover {\r\n    background-color: #6FCBD2;\r\n    transition: background-color 300ms;\r\n  }\r\n  \r\n  \r\n  .letter-link:focus {\r\n    \r\n  }\r\n  \r\n  .letter-link:active,\r\n  .alpha-selector--top:active {\r\n    background-color: #0085B3;\r\n  }\r\n  \r\n  .letter-link,\r\n  .letter-link:visited,\r\n  .alpha-selector--top:visited {\r\n    color: white;\r\n  }\r\n  \r\n  .letter-link:not([href]) {\r\n    background: #D8D8D8;\r\n    cursor: default;\r\n    box-shadow: none;\r\n  }\r\n  \r\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
